var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "QPIcons/Dislike/16px Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RESPONDENT",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pixel-Slate",
    transform: "translate(-128.000000, -411.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(127.000000, 410.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QPIcons/Dislike/16px-Copy-3",
    transform: "translate(8.000000, 8.000000) scale(1, -1) rotate(-180.000000) translate(-8.000000, -8.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,1 L13,1 C14.1045695,1 15,1.8954305 15,3 L15,9 C15,10.1045695 14.1045695,11 13,11 L9,11 L9,13 C9,14.1045695 8.1045695,15 7,15 L5,15 L5,1 Z M1,11 L1,1 L4,1 L4,11 L1,11 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkDislike);
export default __webpack_public_path__ + "static/media/DarkDislike.590bc35b83bc2c04c1ede3031df5d34b.svg";
export { ForwardRef as ReactComponent };